import UserCircleSolidSVG from "@design-system/ui-icons/vanilla/UserCircleSolid"
import { createIcon } from "../createIcon"

export const UserCircleSolidIcon = createIcon(UserCircleSolidSVG)
